import React from 'react';
import SpriteEl from '../SpriteEl/SpriteEl';

function InputSearch({
	placeholder,
	ariaLabelSearch,
	value = "",
	ariaLabelClear,
	disableClass = "",
	onChange,
}) {
	return (
		<label className={`input-search ${disableClass || ''}`}>
			<input
				type="text"
				className="input-search__field"
				placeholder={placeholder}
				value={value}
				onChange={onChange} // Handle text input change
			/>
			<button
				type="button"
				className="input-search__button-search"
				aria-label={ariaLabelSearch}
			>
				<SpriteEl id="search-outline" />
			</button>
			<button
				type="button"
				className="input-search__button-clear"
				aria-label={ariaLabelClear}
			>
				<SpriteEl icon="close-outline" />
			</button>
		</label>
	);
}

export default InputSearch;
